import UnauthorizedSVG from '@Assets/Images/unauthorized.svg';
import styles from './Unauthorized.module.scss';

const Unauthorized = () => (
  <div className={styles.unauthorized}>
    <img src={UnauthorizedSVG} alt='Unauthorized' className='ac2-not-found-img' />
    <h1 className='ac2-error-title'>{"Something's gone wrong"}</h1>
    <h2 className='ac2-error-subtitle'>{'Invalid user.'}</h2>
  </div>
);
export default Unauthorized;
